import { InvoicingCutoffModel } from './../invoicing/invoicing-cutoff.model';
import { RentalPeriodModel } from './rental-period.model';
import { RemissionStateEnums } from '../../enum/remission-state-enums';
import { CostCenterModel } from 'src/app/models/archive/cost-center.model';
export class RemissionModel {
  remissionId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  alterNumber: number | null = null;
  costCenterId: number = 0;
  costCenter: CostCenterModel | null = null;
  dateRemission: Date = new Date;
  rentalPeriodId: number = 0;
  rentalPeriod: RentalPeriodModel | null = null;
  dateInvoice: Date = new Date;
  remissionStateId: number = RemissionStateEnums.open;
  swBlock: boolean = false;
  invoicingCutoffId: number | null = null;
  invoicingCutoff: InvoicingCutoffModel | null = null;
  transportValue: number = 0;
  transportValuePay: number = 0;
  transporterId: number = 0;
  vehicleId: number = 0;
  wildcard: string | null = null;
  wildcard2: string | null = null;
  printObservation: string | null = null;
  observation: string | null = null;
  isTransfer: boolean = false;
  compromiseDate: Date = new Date;
  conceptTypeRequirementId: number | null = null;
  conceptDelayReasonId: number | null = null;
  conceptTypeAvailabilityId: number | null = null;
  userId: number | null = null;
  createDate: Date = new Date;
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //variable para controlar si están limpiando el formulario:
  clearForm: boolean = true;
}